import { Controller } from "@hotwired/stimulus"
import Stimulus from "../../shared/utils/stimulus"

class ListData extends Controller {
  get buttonController() {
    return this.application.getControllerForElementAndIdentifier(
      this.buttonTarget,
      `button`
    )
  }

  copy(evt) {
    navigator.clipboard.writeText(evt.target.dataset.listDataCopyValue)

    evt.target.classList.add(`-copied`)
    window.setTimeout(() => evt.target.classList.remove(`-copied`), 2000)
  }
}

Stimulus.register(`list-data`, ListData)
